import * as React from 'react'
import InteractiveDetails from './InteractiveDetails'
import { Link } from 'gatsby'
import resolveLink from 'utils/resolveLink'
import Img from 'components/common/Img'
import { ImArrowRight2 } from 'react-icons/im'
import SingleLink from './SingleLink'

export default function Megamenu({
	label,
	link: mainLink,
	featuredLinks,
	links,
}) {
	return (
		<li className="text-left <md:w-full">
			<InteractiveDetails
				id={label}
				summary={label}
				contentClassName="inset-x-0"
			>
				<div className="border-line-invert md:rounded-b-2xl md:bg-suede-black md:p-8 md:shadow-lg <md:my-4 <md:border-l <md:px-4">
					<div className="mx-auto flex max-w-screen-xl items-stretch gap-x-10 gap-y-6 <lg:flex-col">
						<div className="grow space-y-4">
							<Link
								className="flex items-end justify-between gap-x-4 transition-colors hover:text-ft-green"
								to={resolveLink(mainLink)}
							>
								<span className="technical-lg">{mainLink.title}</span>
								<span className="with-icon gap-2 <md:hidden">
									See all <ImArrowRight2 className="-rotate-45" />
								</span>
							</Link>

							<ul className="grid items-stretch gap-4 md:grid-cols-[repeat(auto-fit,minmax(250px,1fr))] <md:ml-4">
								{featuredLinks?.map((link, key) => (
									<li className="overflow-hidden rounded-lg" key={key}>
										<Link
											className="group flex h-full flex-col"
											to={resolveLink(link.page)}
										>
											<figure className="border-b border-ft-green-dark transition-[filter] group-hover:brightness-125 <md:hidden">
												<Img className="w-full" image={link.image} />
											</figure>

											<div className="space-y-3 md:h-full md:bg-suede-dark md:p-4">
												<div className="technical transition-colors group-hover:text-ft-green">
													{link.page.title}
												</div>

												<p className="text-sm text-white/70 <md:hidden">
													{link.description}
												</p>
											</div>
										</Link>
									</li>
								))}
							</ul>
						</div>

						<ul className="space-y-3 border-suede-dark lg:space-y-6 lg:border-l lg:pl-10 md:<lg:border-t md:<lg:pt-6">
							{links?.map((link, key) => (
								<li key={key}>
									<SingleLink {...link} />
								</li>
							))}
						</ul>
					</div>
				</div>
			</InteractiveDetails>
		</li>
	)
}
